import type { MechKey } from './keys';

export const vi: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Cơ học · 2D',
  'panel.scene': 'Cảnh',
  'panel.dims': 'Thông số',
  'panel.style': 'Giao diện',
  'panel.action': 'Điều khiển',
  'style.body': 'Vật thể',
  'style.vector': 'Vectơ',
  'style.ground': 'Mặt đất',
  'style.forces': 'Hiển thị lực',
  'style.trace': 'Hiển thị vết',
  'style.labels': 'Nhãn vectơ',
  'hint.line1': 'Nhấn phát để bắt đầu · kéo các vật để di chuyển',
  'hint.line2': 'Sandbox: chọn hình, sau đó nhấp để đặt',
  'scene.incline': 'Mặt phẳng nghiêng',
  'scene.projectile': 'Chuyển động ném',
  'scene.pendulum': 'Con lắc',
  'scene.springMass': 'Hệ lò xo-khối lượng',
  'scene.collisions': 'Va chạm',
  'scene.atwood': 'Máy Atwood',
  'scene.circular': 'Chuyển động tròn',
  'scene.sandbox': 'Sandbox',
  'dim.angle': 'góc (°)',
  'dim.friction': 'ma sát',
  'dim.mass': 'khối lượng',
  'dim.massA': 'khối lượng A',
  'dim.massB': 'khối lượng B',
  'dim.velocity': 'vận tốc',
  'dim.angleLaunch': 'góc phóng (°)',
  'dim.gravity': 'trọng lực',
  'dim.gravityX': 'trọng lực x',
  'dim.gravityY': 'trọng lực y',
  'dim.length': 'chiều dài',
  'dim.damping': 'giảm chấn',
  'dim.spring': 'độ cứng',
  'dim.restitution': 'hệ số phục hồi',
  'dim.radius': 'bán kính',
  'dim.speed': 'tốc độ',
  'action.play': 'Phát',
  'action.pause': 'Tạm dừng',
  'action.step': 'Bước',
  'action.reset': 'Đặt lại',
  'action.speed': 'Tốc độ',
  'action.clear': 'Xóa',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Trọng lực',
  'forceName.normal': 'Lực pháp tuyến',
  'forceName.friction': 'Lực ma sát',
  'forceName.tension': 'Lực căng',
  'forceName.spring': 'Lực lò xo',
  'forceName.applied': 'Lực tác dụng',
  'forceName.air': 'Lực cản không khí',
  'palette.box': 'Hộp',
  'palette.circle': 'Bóng',
  'palette.ramp': 'Dốc',
  'palette.ground': 'Mặt đất',
  'palette.hint': 'Chọn hình, sau đó nhấp vào canvas để đặt.',
  'panel.forces': 'Lực quan sát được',
  'forces.empty': 'Chưa có — hãy phát cảnh',
};
